// src/components/store/sections/faqs/FaqV66TicketfaqRoyalViolet.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV66TicketfaqRoyalViolet(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={66}
      archKey="ticket_faq"
      archLabel="Perforated Ticket Q&A"
      palName="RoyalViolet"
      grad="from-violet-600 via-purple-600 to-indigo-700"
      lightBg="bg-violet-50"
      textCol="text-violet-700"
      borderCol="border-violet-200"
      btnCls="bg-violet-600 hover:bg-violet-700"
      hexCol="#8b5cf6"
      {...props}
    />
  );
}
